import { Box } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import { useForm } from 'react-hook-form';
import { Table } from '../../apiTypes';
import EditModal from '../../components/EditModal';
import FormTextField from '../../components/forms/FormTextField';
import PrimaryButton from '../../components/PrimaryButton';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useLocale } from '../../contexts/locale.context';

type Props = {
  table: Table;
  onSubmit: (table: Table) => void;
  onClose: () => void;
};

const EditTable = ({ table, onClose, onSubmit }: Props) => {
  const { lang } = useLocale();
  const { cafeSlug } = useAdmin();

  const form = useForm<Table>({
    mode: 'onChange',
    defaultValues: table,
  });

  const saveChanges = (newTable: Table) => {
    onSubmit(newTable);
    onClose();
  };

  const link = `https://firemenu.app/qr/${cafeSlug}/table?id=${table.id}`;

  const handleDownload = () => {
    const canvas = document.getElementById('QRCode') as HTMLCanvasElement;
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${t.table[lang]} ${table.name}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <EditModal<Table>
      title={t.table[lang]}
      open
      onClose={onClose}
      submitButton={t.save_changes[lang]}
      onSubmit={saveChanges}
      confirmText={t.remove_store_confirm[lang]}
      form={form}
      size="xs"
    >
      <Box sx={{ py: 2, mb: 1 }}>
        <FormTextField name="name" label={t.name[lang]} rules={{ required: true }} fullWidth />

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <QRCodeCanvas id="QRCode" size={200} style={{ width: '200px', height: '200px' }} value={link} />
          <PrimaryButton variant="text" onClick={handleDownload} sx={{ mt: 1, width: 200 }} color="secondary">
            {t.download[lang]} QR Code
          </PrimaryButton>
        </Box>
      </Box>
    </EditModal>
  );
};

export default EditTable;
